var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-upload',{attrs:{"show-file-list":false,"action":_vm.action,"cathUrl":_vm.cathUrl,"on-success":_vm.onSuccess,"on-error":_vm.uploaderror,"headers":_vm.upLoadHeader,"before-upload":_vm.beforeUpload}},[_c('a',{on:{"click":function($event){return _vm.chageSign()}}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06cd344e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/buttons/name-upload.vue
// module id = null
// module chunks = 